import React from 'react'
import MuiTableBody from '@material-ui/core/TableBody'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import { Column } from '.'

interface Props<T> {
  data: T[]
  columns: Column<T>[]
  onRowClick?: (e: React.MouseEvent<HTMLTableRowElement>, item: T) => void
  //   page: number
  //   rowsPerPage: number
}
const TableBody = <T,>({ columns, data, onRowClick }: Props<T>) => {
  return (
    <MuiTableBody>
      {data.map((item, index) => (
        <TableRow
          onClick={(e) => {
            if (onRowClick) onRowClick(e, item)
          }}
          hover
          style={{ cursor: onRowClick ? 'pointer' : 'unset' }}
          key={index}
        >
          {columns.map((column) => {
            const style = column.style?.(item) ?? {}

            const content = column.content
              ? column.content(item, index) ?? '_'
              : column.path
              ? item[column.path] ?? '_'
              : '_'

            const isString = !!content && typeof content === 'string' && content !== '_'

            const stringStyle = isString
              ? {
                  maxWidth: column.width ?? 100,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }
              : {}

            // if (content && typeof content === 'string' && content !== '_')
            //   return (
            //     <TableCell
            //       align="center"
            //       title={content}
            //       style={{
            //         direction: 'ltr',
            //         maxWidth: 150,
            //         whiteSpace: 'nowrap',
            //         overflow: 'hidden',
            //         textOverflow: 'ellipsis',
            //         ...style,
            //       }}
            //       key={column.id as string}
            //     >
            //       {content}
            //     </TableCell>
            //   )

            return (
              <TableCell
                title={isString ? content : undefined}
                align="center"
                style={{ direction: 'ltr', ...stringStyle, ...style }}
                key={column.id as string}
              >
                {content}
              </TableCell>
            )
          })}
        </TableRow>
      ))}
    </MuiTableBody>
  )
}

export default TableBody
